<div class="row">
  <div class="viber-ctn" style="position: relative;">
    <img ng-if="viberHeader.countryCode !== 'hr'" class="img-ctn" src="img/hypo/addikochat.png"/>
    <img ng-if="viberHeader.countryCode === 'hr'" class="img-ctn" ng-src="img/hypo/addikochat-{{viberHeader.currentLanguage}}.png"/>
  </div>
</div>
